module.exports = __webpack_public_path__ + "media/src/images/404-5aaa2c59516154006668854fecd4fc05.jpg";